import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { CrudService } from '../../../crud/crud.service';

@Component({
  selector: 'app-grupo-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tieneid;
  tab = 1;

  form_modalidades_dias;
  dias_disonibles = [];

  // Mensaje
  titulo; mensaje; clase;

  tamano = document.body.clientHeight;
  constructor(private route: ActivatedRoute, private router: Router, private crudService: CrudService, private fb: FormBuilder, ) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      nombre: ['', [Validators.required]],
      tipo_rvoe: ['', [Validators.required]],
      nombre_imprimir: ['', [Validators.required]],
      duracion_meses: ['', [Validators.required]],
      numero_parciales: ['', [Validators.required]],
      ignorar_redondeo_reprobado: [0],

      parcial_numero_decimales: [0, [Validators.required]],
      materia_numero_decimales: [0, [Validators.required]],
      periodo_numero_decimales: [0, [Validators.required]],
      general_numero_decimales: [0, [Validators.required]],

      materia_tipo_redondeo: ['NINGUNA', [Validators.required]],
      periodo_tipo_redondeo: ['NINGUNA', [Validators.required]],
      parcial_tipo_redondeo: ['NINGUNA', [Validators.required]],
      general_tipo_redondeo: ['NINGUNA', [Validators.required]],

      parcial_leyenda_para_imprimir: [null],
      materia_leyenda_para_imprimir: [null],
      periodo_leyenda_para_imprimir: [null],
      general_leyenda_para_imprimir: [null],

      parcial_valor_para_promediar: [null],
      materia_valor_para_promediar: [null],
      periodo_valor_para_promediar: [null],
      general_valor_para_promediar: [null],

      parcial_leyenda_para_imprimir_np: [null],
      materia_leyenda_para_imprimir_np: [null],
      periodo_leyenda_para_imprimir_np: [null],
      general_leyenda_para_imprimir_np: [null],

      parcial_valor_para_promediar_np: [null],
      materia_valor_para_promediar_np: [null],
      periodo_valor_para_promediar_np: [null],
      general_valor_para_promediar_np: [null],

      modalidades_dias: this.fb.array([])
    });

    this.form_modalidades_dias = {
      dias_semanas_id: ['', [Validators.required]]
    };

    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
    });
    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  descartar(event, data, i){
    let id_seleccionado = this.dato.controls.modalidades_dias.value[i].dias_semanas_id;
    this.dato.controls.modalidades_dias.value.forEach((element, key) => {
      // console.log("muestra: ", element, "seleccionado: ", id_seleccionado)
      //console.log(key, i)
      if (key!=i && element.dias_semanas_id==id_seleccionado) {
        //console.log("muestra: ", element.id, "seleccionado: ", id_seleccionado)
        //this.dato.controls.carreras_planes.value[i].carreras_id = '';
        //console.log(this.dato.controls.carreras_planes[i].controls.carreras_id)
        this.titulo = 'Verifique';
        this.mensaje = 'El día que seleccionó ya la se cargó antes';
        this.clase = 'info';
        document.getElementById("message").click();
      }

      //console.log(this.dato.value)
    });
  }
  actualizar_promedios(){
    this.crudService.ver(this.dato.controls.id.value, 'actualizar-promedio').subscribe(
      resultado => {
      },
      error => {
      }
    );
  }
}
